export const USER_OPTIONS = [
  "id",
  "fullName",
  "login",
  "position",
  "email",
  "phone",
  "role",
  "status",
  "Dealer",
  "dealersCount",
  "lastOnline",
  "isAnnouncementsAccess",
  "isAnnouncementsSend",
];

export const USER_OPTIONS_TABLE = [
  "id",
  "fullName",
  "login",
  "position",
  "email",
  "phone",
  "roleUsers",
  "status",
  "dealersCount",
  "lastOnline",
];

export const orderByChange = (sortField: string | undefined) => {
  if (sortField) {
    if (sortField === "dealersCount") {
      return "dealerCount";
    } else if (sortField === "roleUsers") {
      return "position";
    } else {
      return sortField;
    }
  } else {
    return "id";
  }
};

export const USER_ITEM_MOCK = [
  {
    fullname: "System Test",
    fullnameEn: "System Test",
    login: "SYSTEM_TEST",
    position: "",
    positionEn: null,
    email: "test@test.ru",
    phone: null,
    role: "admin",
    roleEn: "Admin",
    roleRu: "Администратор",
    countDC: 1000,
    status: "active",
    lastOnlineDate: "2025-09-11T10:52:58.882Z",
    id: "-2",
    isEmployeeAccess: true,
    isViolationAccess: false,
    isAnnouncementsAccess: false,
    isTemporaryAccessToAllDealers: false,
    isZdAccess: false,
    isAnnouncementsSend: false,
    isAccountingAccess: false,
    ivideon_access: true,
    dnm_access: true,
    isDocumentsAccess: true,
    isCandidateAccess: true,
    isCameraAccess: true,
    isTrustedPersonAccess: true,
    SubdivisionId: null,
    Subdivision: null,
    __typename: "Profile",
  },
  {
    fullname: "System User",
    fullnameEn: "System User",
    login: "SYSTEM_USER",
    position: "",
    positionEn: null,
    email: "test@test.ru",
    phone: "",
    role: "holding",
    roleEn: "Holding",
    roleRu: "Холдинг",
    countDC: 3,
    status: "active",
    lastOnlineDate: "2025-09-05T08:08:11.452Z",
    id: "-3",
    isEmployeeAccess: true,
    isViolationAccess: true,
    isAnnouncementsAccess: false,
    isTemporaryAccessToAllDealers: false,
    isZdAccess: false,
    isAnnouncementsSend: true,
    isAccountingAccess: false,
    ivideon_access: true,
    dnm_access: false,
    isDocumentsAccess: false,
    isCandidateAccess: false,
    isCameraAccess: false,
    isTrustedPersonAccess: false,
    SubdivisionId: "36",
    Subdivision: {
      id: "36",
      name: "Служба вице-президента по продажам и маркетигу",
      __typename: "Subdivision",
    },
    __typename: "Profile",
  },
];
